<template>
    <div id="main" class="container-fluid">
        <h1>Sorry the page you are looking for was not found.</h1>
    </div>
</template>

<script>
    export default {
        mounted() {
        }
    }
</script>
